



































import {Component, Vue} from "vue-property-decorator";
import EntryComponent from "@/components/EntryComponent.vue";
import {getModule} from "vuex-module-decorators";
import Entries from "@/store/modules/entries";
import {Entry, EntryType} from "@/types/entry";
import NewEntryComponent from "@/components/NewEntryComponent.vue";

@Component({
    components: {
        NewEntryComponent,
        EntryComponent,
    },
})
export default class EntryListComponent extends Vue {

    private entryModule = getModule(Entries);

    private lastSelected: Entry | null = null;

    private fields = {
        _title: {
            label: "Title",
            sortable: true,
        },
        _type: {
            label: "Type",
            sortable: false,
        },
        _amount: {
            label: "Amount",
            sortable: true,
        },
    };

    public get entries() {
        return this.entryModule.getEntries;
    }

    get isBusy(): boolean {
        return this.entryModule.getEntries.length == 0;
    }

    public add() {
        const entry = new Entry("---", EntryType.Daily, "Test Title", 20.5);
        this.entryModule.addEntry(entry);
    }

    public select(entries: Entry[]) {
        if (entries.length == 0) {
            if (this.lastSelected != null) {
                this.lastSelected.showDetails = false;
            }
        } else {
            this.lastSelected = entries[0];
            this.lastSelected.showDetails = true;
        }
    }
}
